
import { MESSAGE5,CASTS } from '../../constants/actionTypes';
import * as api from '../../api/index.js';

export const cast_create = (formData) => async (dispatch) => {
    try {
      const { data } = await api.cast_create(formData);
      dispatch({ type: MESSAGE5, payload:data });
  
   
    } catch (error) {
      console.log(error);
    }
  };

  export const cast_update = (formData) => async (dispatch) => {
    try {
      const { data } = await api.cast_update(formData);
      dispatch({ type: MESSAGE5, payload:data });
  
   
    } catch (error) {
      console.log(error);
    }
  };
  export const cast_delete = (formData) => async (dispatch) => {
    try {
      const { data } = await api.cast_delete(formData);
      dispatch({ type: MESSAGE5, payload:data });
  
   
    } catch (error) {
      console.log(error);
    }
  };
  export const all_cast_list = (formData) => async (dispatch) => {
    try {
      const { data } = await api.all_cast_list(formData);
      
      dispatch({ type: CASTS, payload:data });
  
   
    } catch (error) {
      console.log(error);
    }
  };
  